module.exports = __webpack_public_path__ + "img/360-car_ec-phev.205a4e38.jpg";